{
  "propertyCompanyGroup": {
    "name": "DAS Domus Arctica -säätiö"
  },
  "bulletin": "Bulletins",
  "moreBulletins": "More bulletins",
  "noBulletins": "No new bulletins",
  "test": "test",
  "hi": "Hello,",
  "email": "Email address",
  "emailForContact": "Email for contact",
  "residentId": "Resident app username",
  "phone": "Telephone",
  "comingSoon": "Coming soon",
  "edit": "Edit",
  "cancel": "Cancel",
  "closeButton": "Close",
  "save": "Save",
  "preview": "Preview",
  "next": "Next",
  "file": "File",
  "thankYou": "Thank you",
  "formSent": "{{form}} has been submitted.",
  "editFormSent": "{{form}} has been modified.",
  "backToHome": "Back to the first page",
  "back": "Back",
  "impersonatorWriteOnlyModeError": "As a user logged in on behalf of a customer, there is no right to modify the data.",
  "movedOutReadOnlyModeError": "You have moved out, so you can only view the information and send messages, questions and feedback.",
  "notKnown": "Unknown",
  "yes": "Yes",
  "no": "No",
  "additionalNotification": "For urgent matters, please contact customer services.",
  "logOut": "Log out",
  "showMore": "Show more",
  "waysToCommunicate": "Communication preferences",
  "communicationByEmail": "Email",
  "communicationBySms": "Text message",
  "marketingAllowed": "Marketing consent",
  "paperInvoice": "Paper invoice",
  "eInvoice": "eInvoice",
  "inUse": "In use",
  "notInUse": "Not in use",
  "views": {
    "home": "Home",
    "userInfo": "My information",
    "payments": "Invoices and payment details",
    "defectNotice": "Report a fault",
    "documents": "Documents",
    "bulletin": "Bulletin",
    "building": "Property information",
    "bulletinBoard": "All bulletins",
    "contactInfo": "Contact information"
  },
  "taskLinks": {
    "messages": "Messages",
    "newMessagesCount_one": "{{count}} new message",
    "newMessagesCount_other": "{{count}} new messages",
    "defectNotice": "Faults",
    "payments": "Payments",
    "saunaReservation": "Sauna",
    "commonAreaReservations": "Common areas",
    "moveNotice": "Termination",
    "residentChanges": "Resident changes"
  },
  "navbar": {
    "profile": "Open the profile",
    "home": "Home",
    "transactions": "Services",
    "faultReport": "Fault report",
    "terminateContract": "Terminate the agreement",
    "residentChanges": "Resident changes",
    "messages": "Messages",
    "feedback": "Feedback",
    "questions": "Questions",
    "userInfo": "My information",
    "payments": "Payment details",
    "ownProperty": "My home",
    "documents": "Documents",
    "building": "Property information",
    "openMenu": "Open menu",
    "openProfile": "Open profile",
    "bulletinBoard": "All bulletins",
    "contactInfo": "Contact information",
    "parkingSpots": "Parking spots",
    "saunaReservations": "Sauna reservations",
    "laundryReservations": "Laundry reservations",
    "gymBooking": "Gym bookings",
    "gymReservations": "Gym reservations",
    "commonAreaReservations": "Common area reservations",
    "storages": "Storages"
  },
  "placeholders": {
    "date": "DD.MM.YYYY",
    "select": "Select"
  },
  "datePicker": {
    "monthEndOnly": "The agreement end date is always the last day of the month",
    "monthEndOnlyValidation": "Please choose the last day of the month"
  },
  "today": "Today",
  "week": "Week",
  "month": "Month",
  "copy": "Copy",
  "copyFailed": "Copying failed",
  "userInfo": {
    "securitySectionHeader": "Information security",
    "changePassword": "Change password",
    "strongAuth": {
      "sectionHeader": "Authentication",
      "infoText": "Making contract changes requires authentication. You can authenticate using the button below.",
      "authButton": "Authenticate"
    },
    "description1": "We use this contact information for housing offers, fault reports, contract changes, and other information-related matters.",
    "description2": "The email you use as your resident account username can only be changed by registering again.",
    "communicationPreferencesInfo": "Choose how you would primarily like to receive messages. Your choice does not affect the channels through which essential messages can be delivered.",
    "permissionsHeader": "Permissions",
    "marketingAllowedDescription": "I want to hear about benefits and campaigns",
    "electronicServicesConsent": "Electronic services consent",
    "electronicServicesConsentDescription": "Official documents may be sent to me electronically",
    "removeUser": {
      "buttonText": "Delete account",
      "confirmationText": "Are you sure you want to delete your account?"
    }
  },
  "complete": "Complete",
  "tryAgain": "Try again",
  "reloadPage": "Reload page",
  "newVersionAvailable": "A new version of the resident pages is available. Please reload the page.",
  "newVersionTitle": "The resident pages have been updated!",
  "closeWindow": "Close without reloading",
  "alt": {
    "illustration": "illustration"
  },
  "uploadFilesInputText": "Click here or drag and drop the file. The maximum file size is 10 Mb.",
  "uploadFilesInputError": "Your file is too large or in the wrong format. Allowed file types:",
  "cookieConsent": {
    "readMoreLinkText": "Learn more about DAS's cookie policy here",
    "readMoreLink": "https://www.das.fi/fi/tietoa-dasista/henkilotietojen-kaytto"
  },
  "buildingInfo": {
    "title": "Basic information",
    "district": "District",
    "constructionDate": "Year of construction",
    "realPropertyAreasTotal": "Apartments",
    "heatingMethod": "Heating method",
    "internetOperator": "Internet operator",
    "internetProvider": "Internet provider",
    "connectionSpeed": "Connection speed",
    "realPropertyPictureAlt": "Picture of the property",
    "contactInformation": "Contact information",
    "noContactInformation": "No contact information available",
    "sales": "Sales",
    "residentsCommittee": "Residents committee",
    "giveFeedback": "Give feedback",
    "askQuestion": "Ask about housing",
    "heatingMethods": {
      "airToWaterHeatPump": "Air-to-water heat pump",
      "districtAndExhaustAirHeatPump": "District and exhaust air heat pump",
      "districtAndSolar": "District and solar",
      "districtHeating": "District heating",
      "electricHeating": "Electric heating",
      "gas": "Gas",
      "geothermalAndSolar": "Geothermal and solar",
      "geothermalHeating": "Geothermal heating",
      "naturalGasHeating": "Natural gas heating",
      "noHeating": "No heating",
      "notSet": "Not set",
      "oilHeating": "Oil heating",
      "solar": "Solar energy"
    }
  },
  "charactersRemaining": "Characters remaining: {{count}}",
  "sensitiveDataWarning": "Note! Please make sure that the message does not include any sensitive personal information, such as a personal identification number, passwords, or other confidential details.",
  "dateTime": {
    "weekAbbreviation": "wk",
    "today": "Today",
    "months": {
      "in": {
        "10": "in October",
        "11": "in November",
        "12": "in December",
        "01": "in January",
        "02": "in February",
        "03": "in March",
        "04": "in April",
        "05": "in May",
        "06": "in June",
        "07": "in July",
        "08": "in August",
        "09": "in September"
      }
    }
  },
  "residentDetailsTitle": "Additional information",
  "textEditor": {
    "heading1": "Heading 1",
    "heading2": "Heading 2",
    "paragraph": "Paragraph",
    "bulletedList": "Bulleted list",
    "numberedList": "Numbered list",
    "text": "Text",
    "link": "Link",
    "addLink": "Add link",
    "removeLink": "Remove",
    "italic": "Italic",
    "bold": "Bold",
    "underline": "Underline",
    "undo": "Undo",
    "redo": "Redo",
    "textRequired": "Text is required",
    "linkRequired": "Link is required",
    "linkInvalid": "Link is not a valid URL"
  },
  "openFile": {
    "loadingTitle": "Loading…",
    "loading": "Loading document…",
    "loadingSlow": "Loading is taking longer than usual…",
    "errorTitle": "Error",
    "failed": "Failed to open the file."
  }
}